import { io } from "socket.io-client";

/**
 * Socket.IO Configuration - UNIFIED BACKEND
 * 
 * The socket backend and recording backend have been merged into a single server.
 * Both socket and recordingSocket now connect to the same unified backend.
 */

// Single unified socket URL
export const baseUrl = process.env.REACT_APP_SOCKET_URL || 'https://virtual-ws.perla-tech.com/';

// For backwards compatibility - unified by default, override if needed
export const baseUrlRecording = process.env.REACT_APP_RECORDING_URL || baseUrl;

/**
 * Main socket for real-time communication
 */
export const socket = io(baseUrl, { 
    autoConnect: false,
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionAttempts: 10,
    timeout: 20000,
    transports: ['websocket', 'polling'],
});

/**
 * Recording socket - SAME server (unified backend)
 * The server distinguishes recording connections via the `isRecording` auth flag
 */
export const recordingSocket = io(baseUrlRecording, {
    autoConnect: false,
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionAttempts: 10,
    timeout: 20000,
    transports: ['websocket', 'polling'],
});

/**
 * Helper to connect recording socket with isRecording flag
 */
export const connectRecordingSocket = (auth) => {
    recordingSocket.auth = { ...auth, isRecording: true };
    recordingSocket.connect();
};

/**
 * Helper to connect main socket
 */
export const connectMainSocket = (auth) => {
    socket.auth = { ...auth, isRecording: false };
    socket.connect();
};

// Debug logging for development
if (process.env.NODE_ENV === 'development') {
    socket.on('connect', () => console.log('[Socket] Connected:', socket.id));
    socket.on('disconnect', (reason) => console.log('[Socket] Disconnected:', reason));
    socket.on('connect_error', (error) => console.log('[Socket] Connection error:', error.message));
    
    recordingSocket.on('connect', () => console.log('[Recording Socket] Connected:', recordingSocket.id));
    recordingSocket.on('disconnect', (reason) => console.log('[Recording Socket] Disconnected:', reason));
}

export default socket;
